import Swup from 'swup';
// import SwupScriptsPlugin from '@swup/scripts-plugin/dist/SwupScriptsPlugin.min';
// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cards';
import 'swiper/css/free-mode';

// Import Alpine components
import './components/accordion.js';
import './components/rule.js';
import './components/spacer.js';
import './components/cursorFollower.js';
import { initCarousel } from './components/swiper.js';
import { initStoreLocator } from './components/map.js';
import { autoInitProductSliders } from './components/product-slider.js';
import { autoInitProductsPagination } from './components/products-pagination.js';

window.isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;


const options = {
  plugins: [
    // new SwupScriptsPlugin()
  ]
};

// Register Alpine plugins before starting
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

// Make Alpine available globally
window.Alpine = Alpine;

// Make carousel init function globally available
window.initCarousel = initCarousel;

// Make map init function globally available
window.initStoreLocator = initStoreLocator;
window.storeLocatorMap = null;

// Map state management - watch for hash changes
const initMapStateManagement = () => {
  let currentMapState = false;

  const checkHash = () => {
    const shouldBeOpen = window.location.hash === '#find-a-stockist';
    const mapElement = document.getElementById('find-a-stockist');

    if (currentMapState !== shouldBeOpen) {
      console.log('🔄 Hash state changed - updating map to:', shouldBeOpen);
      currentMapState = shouldBeOpen;

      if (mapElement) {
        if (shouldBeOpen) {
          mapElement.classList.add('active');
          console.log('✅ Added active class to map');
        } else {
          mapElement.classList.remove('active');
          console.log('❌ Removed active class from map');
        }
      }

      // Mirror state to Alpine so :inert binding on .map updates reactively
      if (window.Alpine) {
        const bodyData = Alpine.$data(document.body);
        if (bodyData) {
          bodyData.mapActive = shouldBeOpen;
        }
      }

      // When the map opens, move focus to the .map section. We wait one frame
      // so Alpine has cleared the :inert attribute (you can't focus an inert
      // element).
      if (shouldBeOpen && mapElement) {
        requestAnimationFrame(() => {
          mapElement.focus({ preventScroll: true });
        });
      }
    }
  };

  // Check immediately
  checkHash();

  // Listen for hash changes
  window.addEventListener('hashchange', checkHash);

  // Polling as fallback (every 500ms)
  setInterval(checkHash, 500);
};

const swup = new Swup(options);

// Events
swup.hooks.on('content:replace', init);

// Tear down Cloudflare Turnstile widgets before Swup swaps content so
// internal Turnstile state doesn't reference the outgoing DOM nodes.
swup.hooks.on('visit:start', () => {
  if (window.turnstile) window.turnstile.remove();
});

document.addEventListener('DOMContentLoaded', () => {
  l('ready');
  // Start Alpine.js
  Alpine.start();
  // checkCookie();
  init();
  // Initialize map hash management AFTER Alpine.start() so the :inert
  // binding on .map is in place before the initial checkHash() tries to
  // focus the section. Without this, direct loads to /#find-a-stockist
  // fire focus before Alpine has cleared inert and the call silently fails.
  initMapStateManagement();
});

// Functions 

// Better console.log – only for local .test urls
function l(m) {
  if (window.location.hostname.split('.').at(-1) == 'test') {
    console.log(m);
  }
}

function init() {
  l('👍');

  // Update global isMobile state on page transitions
  if (window.Alpine && Alpine.store) {
    const bodyData = Alpine.$data(document.body);
    if (bodyData) {
      bodyData.isMobile = window.innerWidth < 768;
    }
  }

  if (typeof window.initCarousel === 'function') {
    const carousels = document.querySelectorAll('.carousel-container:not([data-carousel-initialized])');
    carousels.forEach(function (container) {
      container.setAttribute('data-carousel-initialized', 'true');
      window.initCarousel(container);
    });
  }

  // Initialize product sliders
  autoInitProductSliders();

  // Initialize mobile pagination dots for .products.feed slider
  autoInitProductsPagination();

  // Reinitialize Alpine.js for new content loaded by Swup
  const swupContainer = document.querySelector('#swup');
  if (swupContainer) {
    Alpine.initTree(swupContainer);
  }

  // Render Cloudflare Turnstile widgets. The api.js script is loaded once in
  // <head>, so on Swup navigations the auto-render on DOMContentLoaded won't
  // fire again — call render() manually for any freshly-swapped widgets.
  if (window.turnstile) {
    document.querySelectorAll('.cf-turnstile').forEach((el) => {
      if (!el.dataset.turnstileRendered) {
        window.turnstile.render(el);
        el.dataset.turnstileRendered = 'true';
      }
    });
  }
}